//#region DevExtreme Imports

import 'devextreme/ui/check_box'
import 'devextreme/ui/date_box'
import 'devextreme/ui/form'
import 'devextreme/ui/number_box'
import 'devextreme/ui/popup'
import 'devextreme/ui/radio_group'
import 'devextreme/ui/select_box'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/toolbar'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'

import { DATE_BOX_CONTROLS_SERVICE_NAME, DateBoxControlsService } from '../../../services/controls'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { LoggerService } from '../../common/common.module'

import { ActionRunController } from './action-run.controller'
import { ACTION_SERVICE_NAME, ActionService } from '../../../services/action'

//#region Asset Imports

import './action-run.scss'
import * as TEMPLATE from './action-run.tpl.html'

//#endregion

export class ActionRunDirective implements ng.IDirective {
    restrict = 'E'

    scope = {
        popupId: '=',
        source: '=?'
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        '$element',
        $TIMEOUT_SERVICE_NAME,
        'api',
        'logger',
        'localDictionary',
        DATE_BOX_CONTROLS_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        ACTION_SERVICE_NAME,
        (
            $scope,
            $q: ng.IQService,
            $element: JQuery,
            $timeout: ng.ITimeoutService,
            api: Api,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            dateBoxControlsService: DateBoxControlsService,
            userSession: UserSessionService,
            actionService: ActionService
        ) => {
            return new ActionRunController($scope, $q, $element, $timeout, api, logger, localDictionary, dateBoxControlsService, userSession, actionService)
        }
    ]

    template = TEMPLATE
    transclude = true
}

